<template>
  <div>
    <el-dialog
      title="请您填写退回意见"
      :visible.sync="visible"
      width="40%"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="100px"
        v-loading="loading"
      >
        <el-form-item label="退回意见" prop="feedback">
          <el-input
            type="textarea"
            v-model="form.feedback"
            placeholder="请输退回意见"
            maxlength="200"
            show-word-limit
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="handleBack">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { flowBack } from '@/api/shares/opers/flow.js';

export default {
  data() {
    return {
      visible: false,
      loading: false,
      form: {},
      // 表单校验
      rules: {
        feedback: [{ required: true, message: '请输退回意见', trigger: 'blur' }]
      }
    };
  },
  methods: {
    handleBack() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.doBack();
        } else {
          return false;
        }
      });
    },
    doBack() {
      this.loading = true;
      flowBack(this.$route.params.shareEid, this.form).then(res => {
        this.loading = false;
        this.msgSuccess('退回成功！', function() {
          window.close();
        });
      });
    },
    show() {
      this.visible = true;
    }
  }
};
</script>

<style></style>
